import { useQuery } from '@tanstack/react-query'
import { accessControlApi } from '../api/access-control.client'

export const ROLES_QUERY_KEY = ['access-control', 'roles'] as const

export function useRolesQuery() {
  return useQuery({
    queryKey: ROLES_QUERY_KEY,
    queryFn: () => accessControlApi.listRoles(),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
